import type { ReactNode } from 'react';

export const symbol_tablet_android: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-40q-24.75 0-42.37-17.63Q120-75.25 120-100v-760q0-24.75 17.63-42.38Q155.25-920 180-920h600q24.75 0 42.38 17.62Q840-884.75 840-860v760q0 24.75-17.62 42.37Q804.75-40 780-40H180Zm0-150v90h600v-90H180Zm238 65h124q8 0 14-6t6-14q0-8-6-14t-14-6H418q-8 0-14 6t-6 14q0 8 6 14t14 6ZM180-250h600v-520H180v520Zm0-580h600v-30H180v30Zm0 0v-30 30Zm0 640v90-90Z"
		/>
	</svg>
);
